
import {of as observableOf,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { LogoutEmitServiceService } from '../services/logout-emit-service.service';
import { EmitterService } from '../services/emitter.service';
import { Router } from '@angular/router';




@Injectable()
export class HttpResponseHandlerService {

  sessionout : boolean= false;
  isMaintainance: boolean = false;

  constructor(
    private logoutForceService: LogoutEmitServiceService,
    private router:Router,
    private emitterService: EmitterService
  ) {}



    handleHTTPResponse (response){
      if (response.session_expired_sso || (response.errors && response.errors.length > 0 && response.errors[0].errorCode === 100187)){
        this.emitterService.broadcastlogoutComplete("userLoggedOff");
        localStorage.removeItem('sessionTimerInfo'); 
        return response;
      }else if (response.error === 151) {
        if (!this.sessionout) {
          this.sessionout = true;
          this.emitterService.broadcastlogoutComplete("userSessionOff");
          localStorage.removeItem('sessionTimerInfo'); 
        }
        this.router.navigate(["/" + localStorage.getItem("langCode")]);
      } else if (response.error === 150) {
        this.isMaintainance = true;
        this.emitterService.broadcastMaintenanceEmitter(true);
      } else if (response && response.isIpBlocked && response.isIpBlocked === true) {
        throw new Error("countryBlocked:" + response.countryCode);
      } else {
        if (!this.isMaintainance) {
          this.emitterService.broadcastMaintenanceEmitter(false);
          return response;
        }
      }

    }

    handleHTTPError(e,url,observable?) {
      if (e.message && e.message.includes("countryBlocked")) {
        this.logoutForceService.broadcastCountryBlockEvent(e.message.split(":")[1]);
      } else {
        if (e.status === 401) {
          this.logoutForceService.broadcastForceLogout("");
        } else {
          if (url.includes("makeCCPayment") || url.includes("makeWalletPayment"))
            this.logoutForceService.broadcastTimeOutEvent("Transaction Timed Out");
        }
      }

      if(observable){
        return observableOf(null);
      }

    }

}
